(function () {
    'use strict';

    angular
        .module('app')
        .controller('LeadsEditController', LeadsEditController);

    LeadsEditController.$inject = ['debug', '$stateParams', 'i18n', 'API', '$state', 'alert'];

    function LeadsEditController(debug, $stateParams, i18n, API, $state, alert) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.lead = {
            translations: {},
        };
        vm.loadingState = {
            leadIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;

        activate();

        function activate() {
            loadLead();
        }

        function loadLead() {
            vm.loadingState.leadIsLoading = true;
            API.Lead.get({ id: vm.id, }).$promise.then(function (response) {
                debug.log(response);
                angular.extend(vm.lead, response);
                vm.loadingState.leadIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function () {
                var removePromise = API.Lead.delete({ id: vm.id }).$promise;

                removePromise.then(function () {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('LEAD_REMOVED') });
                    $state.go('leads.list');
                }, function () {
                });
            }, function () {
            });
        }
    }
})();